import React from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

// Create an Emotion cache
const emotionCache = createCache({
  key: 'css',
  prepend: true, // This ensures emotion styles are loaded first, allowing for proper overrides
});

// Wrap the root element with the Emotion CacheProvider
export const wrapRootElement = ({ element }) => (
  <CacheProvider value={emotionCache}>
    {element}
  </CacheProvider>
);
